// src/Api/axiosClient.js
import axios from "axios";
import { API_BASE } from "../config";

const axiosClient = axios.create({
  baseURL: API_BASE,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 20000, // 20 seconds
});

// ---------------- Request Interceptor ----------------
axiosClient.interceptors.request.use(
  (config) => {
    try {
      let token = localStorage.getItem("token");

      if (!token) {
        const storedUser = localStorage.getItem("user");
        if (storedUser) token = JSON.parse(storedUser)?.token;
      }

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch {
      // silently fail in production
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ---------------- Response Interceptor ----------------
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // silently reject errors without showing any messages
    return Promise.reject(error);
  }
);

export default axiosClient;
